export default __webpack_public_path__ + "static/media/Icon-AI-Scanner-Wordmark-Mikke.59acf542.svg";